import { Box, Button, Divider, Typography } from "@mui/joy";
import { FormProvider, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { ManufacturerConfiguration } from "../../Create/components";
import { Action } from "./Action";
import newManufacturerResolver from "../../../../../libs/form-validations/new-manufacturer";
import type { IManufacturer } from "../../../../../interfaces";

interface ManufacturerDetailsProps {
    manufacturer: IManufacturer;
    onUpdate: (data: Partial<IManufacturer>) => Promise<void>;
    onDelete: () => Promise<void>;
    isUpdating: boolean;
    isDeleting: boolean;
}

export function ManufacturerDetails({
    manufacturer,
    onUpdate,
    onDelete,
    isUpdating,
    isDeleting,
}: ManufacturerDetailsProps) {
    const navigate = useNavigate();

    const methods = useForm({
        resolver: newManufacturerResolver,
        defaultValues: {
            Name: manufacturer.Name || "",
            ShortName: manufacturer.ShortName || "",
            Headquarters: manufacturer.Headquarters || "",
            Founded: manufacturer.Founded || "",
            Industry: manufacturer.Industry || "",
            Website: manufacturer.Website || "",
            Status: manufacturer.Status || "Active",
        },
    });

    const onSubmit = methods.handleSubmit(async (data) => {
        await onUpdate({
            Name: data.Name,
            ShortName: data.ShortName,
            Headquarters: data.Headquarters || undefined,
            Founded: data.Founded || undefined,
            Industry: data.Industry || undefined,
            Website: data.Website || undefined,
            Status: data.Status || undefined,
        });
    });

    return (
        <Box component="div" width="100%" p={2} overflow="auto">
            <FormProvider {...methods}>
                <form onSubmit={onSubmit}>
                    <Box component="div" display="flex" flexDirection="column" maxWidth={800}>
                        <Box>
                            <Typography level="title-lg">Manufacturer Details</Typography>
                            <Typography level="body-sm">Update the manufacturer information below.</Typography>
                        </Box>

                        <ManufacturerConfiguration />

                        <Box display="flex" gap={2} justifyContent="flex-start" mt={3}>
                            <Button
                                variant="outlined"
                                color="neutral"
                                onClick={() => navigate("/admin/manufacture/list")}
                            >
                                Cancel
                            </Button>
                            <Button
                                type="submit"
                                disabled={isUpdating || !methods.formState.isDirty}
                                loading={isUpdating}
                                loadingPosition="start"
                                variant="soft"
                                color="primary"
                            >
                                Update Manufacturer
                            </Button>
                        </Box>

                        <Action onDelete={onDelete} isDeleting={isDeleting} manufacturerName={manufacturer.Name} />
                    </Box>
                </form>
            </FormProvider>
        </Box>
    );
}
